// export const BASE_URL = "http://localhost:5000";
export const BASE_URL = "https://du-north-brampton-server.herokuapp.com"; // production
// export const BASE_URL = "https://wiretree-backend.herokuapp.com"; // development